import { render } from "./PagePreviewGallery.vue?vue&type=template&id=fd9fc37c&scoped=true"
import script from "./PagePreviewGallery.vue?vue&type=script&lang=js"
export * from "./PagePreviewGallery.vue?vue&type=script&lang=js"

import "./PagePreviewGallery.vue?vue&type=style&index=0&id=fd9fc37c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd9fc37c"]])

export default __exports__